import * as ambassadorWixBenefitProgramsV1Balance from './benefit-programs-v1-balance-balances.http.js';
import * as ambassadorWixBenefitProgramsV1BalanceTypes from './benefit-programs-v1-balance-balances.types.js';
import * as ambassadorWixBenefitProgramsV1BalanceUniversalTypes from './benefit-programs-v1-balance-balances.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getBalance(): __PublicMethodMetaInfo<
  'GET',
  { poolId: string },
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.GetBalanceRequest,
  ambassadorWixBenefitProgramsV1BalanceTypes.GetBalanceRequest,
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.GetBalanceResponse,
  ambassadorWixBenefitProgramsV1BalanceTypes.GetBalanceResponse
> {
  const payload = { poolId: ':poolId' } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1Balance.getBalance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/balances/{poolId}',
    pathParams: { poolId: 'poolId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listBalances(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.ListBalancesRequest,
  ambassadorWixBenefitProgramsV1BalanceTypes.ListBalancesRequest,
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.ListBalancesResponse,
  ambassadorWixBenefitProgramsV1BalanceTypes.ListBalancesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1Balance.listBalances(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/balances',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBalances(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.QueryBalancesRequest,
  ambassadorWixBenefitProgramsV1BalanceTypes.QueryBalancesRequest,
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.QueryBalancesResponse,
  ambassadorWixBenefitProgramsV1BalanceTypes.QueryBalancesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1Balance.queryBalances(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/balances/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function changeBalance(): __PublicMethodMetaInfo<
  'POST',
  { poolId: string },
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.BalanceChangeBalanceRequest,
  ambassadorWixBenefitProgramsV1BalanceTypes.BalanceChangeBalanceRequest,
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.ChangeBalanceResponse,
  ambassadorWixBenefitProgramsV1BalanceTypes.ChangeBalanceResponse
> {
  const payload = { poolId: ':poolId' } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1Balance.changeBalance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/balances/{poolId}/change',
    pathParams: { poolId: 'poolId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function revertBalanceChange(): __PublicMethodMetaInfo<
  'POST',
  { transactionId: string },
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.RevertBalanceChangeRequest,
  ambassadorWixBenefitProgramsV1BalanceTypes.RevertBalanceChangeRequest,
  ambassadorWixBenefitProgramsV1BalanceUniversalTypes.RevertBalanceChangeResponse,
  ambassadorWixBenefitProgramsV1BalanceTypes.RevertBalanceChangeResponse
> {
  const payload = { transactionId: ':transactionId' } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1Balance.revertBalanceChange(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/balances/changes/{transactionId}/revert',
    pathParams: { transactionId: 'transactionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Balance as BalanceOriginal,
  CommonIdentificationData as CommonIdentificationDataOriginal,
  CommonIdentificationDataIdOneOf as CommonIdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  BalanceAmount as BalanceAmountOriginal,
  PoolInfo as PoolInfoOriginal,
  RolloverConfigurationInfo as RolloverConfigurationInfoOriginal,
  PoolStatus as PoolStatusOriginal,
  PoolStatusWithLiterals as PoolStatusWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GetBalanceRequest as GetBalanceRequestOriginal,
  GetBalanceResponse as GetBalanceResponseOriginal,
  ListBalancesRequest as ListBalancesRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListBalancesResponse as ListBalancesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryBalancesRequest as QueryBalancesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryBalancesResponse as QueryBalancesResponseOriginal,
  BalanceChangeBalanceRequest as BalanceChangeBalanceRequestOriginal,
  BalanceChangeBalanceRequestOperationOneOf as BalanceChangeBalanceRequestOperationOneOfOriginal,
  ChangeBalanceRequestType as ChangeBalanceRequestTypeOriginal,
  ChangeBalanceRequestTypeWithLiterals as ChangeBalanceRequestTypeWithLiteralsOriginal,
  AdjustOptions as AdjustOptionsOriginal,
  LimitRule as LimitRuleOriginal,
  LimitRuleWithLiterals as LimitRuleWithLiteralsOriginal,
  BalanceType as BalanceTypeOriginal,
  BalanceTypeWithLiterals as BalanceTypeWithLiteralsOriginal,
  SetOptions as SetOptionsOriginal,
  SetInitialOptions as SetInitialOptionsOriginal,
  TransactionDetails as TransactionDetailsOriginal,
  Item as ItemOriginal,
  ChangeBalanceResponse as ChangeBalanceResponseOriginal,
  BalanceExceededLimits as BalanceExceededLimitsOriginal,
  BulkChangeBalancesRequest as BulkChangeBalancesRequestOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  ChangeBalanceRequest as ChangeBalanceRequestOriginal,
  ChangeBalanceRequestOperationOneOf as ChangeBalanceRequestOperationOneOfOriginal,
  BulkChangeBalancesResponse as BulkChangeBalancesResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkChangeBalanceResult as BulkChangeBalanceResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  RevertBalanceChangeRequest as RevertBalanceChangeRequestOriginal,
  RevertBalanceChangeResponse as RevertBalanceChangeResponseOriginal,
  ChangeAlreadyReverted as ChangeAlreadyRevertedOriginal,
  NotEnoughBalance as NotEnoughBalanceOriginal,
  GetTransactionReversibilityRequest as GetTransactionReversibilityRequestOriginal,
  GetTransactionReversibilityResponse as GetTransactionReversibilityResponseOriginal,
  TransactionReversibility as TransactionReversibilityOriginal,
  TransactionReversibilityWithLiterals as TransactionReversibilityWithLiteralsOriginal,
  HealBalanceRequest as HealBalanceRequestOriginal,
  HealBalanceResponse as HealBalanceResponseOriginal,
  HealBalanceTenantRequest as HealBalanceTenantRequestOriginal,
  HealBalanceTenantResponse as HealBalanceTenantResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  ChangeBalanceApplicationErrors as ChangeBalanceApplicationErrorsOriginal,
  RevertBalanceChangeApplicationErrors as RevertBalanceChangeApplicationErrorsOriginal,
} from './benefit-programs-v1-balance-balances.types.js';
